import { cccApiUrl } from '../config';

export type LoginConfigStatus = {
  ok: boolean;
  message: string;
};

/** CCC login uses backend API — validate URL can be built (no client Cognito SDK). */
export function getCccLoginConfigStatus(): LoginConfigStatus {
  try {
    const loginUrl = cccApiUrl('/api/ccc/auth/login');
    if (!loginUrl || typeof loginUrl !== 'string') {
      return {
        ok: false,
        message: 'Configuração da API de login em falta. Verifique VITE_CCC_API_URL ou o proxy Nginx.',
      };
    }
    if (!loginUrl.includes('/api/ccc/auth')) {
      return {
        ok: false,
        message: 'URL de autenticação CCC inválida.',
      };
    }
    return { ok: true, message: '' };
  } catch {
    return {
      ok: false,
      message: 'Erro ao ler a configuração de login.',
    };
  }
}
